import { coachingApi } from "./coaching-api";
import { type Requester } from "./coaching-services-transport";
import {
  createCoachingAuthService,
  createPlatformEventsService,
  createProfileService
} from "./coaching-account-services";
import { createPlatformOrganizationsService } from "./coaching-platform-organizations";
import {
  createCohortsService,
  createCompaniesService,
  createHistoryService,
  createProgramsService,
  createResourcesService,
  createUsersService
} from "./coaching-catalog-services";
import {
  analyticsServices,
  createDashboardService,
  createParticipantsService,
  createReportsService,
  createSessionsService
} from "./coaching-engagement-services";

// Shared transport (requestContract, org-id injection/bootstrap, list/record/
// operation helpers, requester types) re-exported so the Z6 / readiness /
// follow-through families keep importing it from this barrel unchanged.
export * from "./coaching-services-transport";

// Facade split (audit 2026-06-12 medium): the former 459-LOC factory is now
// composed from per-domain sibling factories (account/catalog/engagement) on
// top of the shared transport module; the public service shape is unchanged.
export function createCoachingServices(requester: Requester = coachingApi, platformAuthRequester?: Requester) {
  const auth = createCoachingAuthService(requester, platformAuthRequester);

  return {
    auth,
    companies: createCompaniesService(requester),
    programs: createProgramsService(requester),
    cohorts: createCohortsService(requester),
    participants: createParticipantsService(requester),
    sessions: createSessionsService(requester),
    reports: createReportsService(requester),
    analytics: analyticsServices(requester),
    resources: createResourcesService(requester),
    history: createHistoryService(requester),
    dashboard: createDashboardService(requester),
    users: createUsersService(requester),
    profile: createProfileService(requester, auth),
    platformOrganizations: createPlatformOrganizationsService(requester),
    platformEvents: createPlatformEventsService()
  };
}

export const coachingServices = createCoachingServices();
